import { Moment, Duration } from 'moment';

import { ItemOrderHistoryBase } from 'app/buffer-graph/models/item-order-history/item-order-history-base';
import {ItemOrderHistoryLine} from "./item-order-history-line";

export class ItemOrderHistoryFresh extends ItemOrderHistoryBase<ItemOrderHistoryFresh> {
    constructor(
        id: string,
        orderId: number,
        innerOrderId: number,
        date: string,
        planArriveDate: string,
        documentNo: number,
        order: string,
        orderType: string,
        distOrder: number,
        sentOrder: number,
        sentOrderStyle: number,
        status: number,
        statusDesc: string,
        statusDescStyle: number,
        fulfillment: number,
        fulfillmentDesc: string,
        fulfillmentDescStyle: number,
        arrivalDate: string,
        arrivedQuantity: number,
        supplierCode: string,
        supplierName: string,
        buffer: string,
        safetyStock: string,
        balance: number,
        inTransit: number,
        need: number,
        hasData: string,
        hasMoq: string,
        hasMoa: string,
        extraAttribute: string,
        purchasePrice: number,
        public readonly nextInputDate: string,
        public readonly orderTime: Duration,
        public readonly deliveryTime: Duration,
        public readonly lifeTime: number,
        public readonly weekSale: number,
        public readonly lastWeekSale: number,
        public readonly changedCoeff: number,
        public readonly baseBuffer: number,
        public readonly actionQnt: number,
        public readonly newMover: number,
        public readonly newMoverDesc: string,
        public readonly hasHolidayQnt: string,
        isCwh: boolean,
        crossDock: ItemOrderHistoryFresh) {
        super(
            id,
            orderId,
            innerOrderId,
            date,
            planArriveDate,
            documentNo,
            order,
            orderType,
            distOrder,
            sentOrder,
            sentOrderStyle,
            status,
            statusDesc,
            statusDescStyle,
            fulfillment,
            fulfillmentDesc,
            fulfillmentDescStyle,
            arrivalDate,
            arrivedQuantity,
            supplierCode,
            supplierName,
            buffer,
            safetyStock,
            balance,
            inTransit,
            need,
            hasData,
            hasMoq,
            hasMoa,
            extraAttribute,
            purchasePrice,
            isCwh,
            crossDock);
    }
}





// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history-fresh.ts